import { BufferAttribute, BufferGeometry, Vector3 } from 'three';
import { Point3D } from '../../../../team-apis/otterdam/answers/shape-typings';
import { CuboidLocationState3D } from '../../../state/cuboid-location-state-3d';
import { buildCuboidPointsFromShapeLocation } from '../../../utils/cuboid-utils';
import { CloudAttributes } from '../../../utils/kd-tree/cloud-attributes.service';
import { pointToVector } from '../../../utils/point-cloud-utils';

export function updateGeometryAttributes(
  geometry: BufferGeometry,
  data?: CloudAttributes,
) {
  updateGeometryAttribute(geometry, 'position', data?.position);
  updateGeometryAttribute(geometry, 'intensity', data?.intensity);
  updateGeometryAttribute(geometry, 'sourceId', data?.sourceId);
  updateGeometryAttribute(geometry, 'instanceId', data?.instanceId);
}

export function getVerticesFromLocation(
  location: CuboidLocationState3D | undefined,
): [Vector3, Vector3, Vector3, Vector3] {
  let position: Point3D = [0, 0, 0];
  let rotation: Point3D = [0, 0, 0];
  let scale: Point3D = [0, 0, 0];

  if (location) {
    position = location.position;
    rotation = location.rotation;
    scale = location.scale;
  }

  const points = buildCuboidPointsFromShapeLocation({
    position,
    rotation,
    scale,
  }).map((point) => pointToVector(point));

  return [points[0], points[1], points[2], points[4]];
}

function updateGeometryAttribute(
  geometry: BufferGeometry,
  key: keyof CloudAttributes,
  attribute?: BufferAttribute,
) {
  if (attribute) {
    geometry.setAttribute(key, attribute);
  } else {
    geometry.deleteAttribute(key);
  }
}
